import React, {useEffect} from "react";
import {useStyles} from "./styles/SummaryContentStyle";
import SummaryContentsTable from "./SummaryContentsTable";
import EduContentsControl from "../components/control/EduContentsControl";
import {Box, Typography} from "@material-ui/core";
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";

function SummaryContents(props) {
    const { summaryContentStore } = props;
    const classes = useStyles();
    const {intl} = props;

    useEffect(() => {
        summaryContentStore.init();
        summaryContentStore.getSummaryContents();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    return (
        <div className={classes.root}>

            <EduContentsControl />
            {summaryContentStore.summaryContentList.length === 0 ?
                <Box className={classes.emptyBox}>
                    <Typography>{intl.formatMessage({id: "msg_info_empty_content1"})}<br/>{intl.formatMessage({id: "msg_info_empty_content2"})}</Typography>
                </Box>
                :
                <SummaryContentsTable rows={summaryContentStore.summaryContentList}/>
            }
        </div>
    );
}

export default inject('summaryContentStore')(injectIntl(observer(SummaryContents)));
